<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col>
                <date-picker
                  v-model="form.startDate"
                  label="Start Date *"
                  :error-messages="[].concat(fieldErrors('form.startDate'))"
                  @blur="$v.form.startDate.$touch()"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="6">
                <div>
                  <time-picker
                    v-model="form.startTime"
                    label="Time *"
                    :error-messages="[].concat(fieldErrors('form.startTime'))"
                    @blur="$v.form.startTime.$touch()"
                  />
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <date-picker
                  v-model="form.endDate"
                  label="End Date *"
                  :error-messages="[].concat(fieldErrors('form.endDate'))"
                  @blur="$v.form.endDate.$touch()"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="6">
                <div>
                  <time-picker
                    v-model="form.endTime"
                    label="Time *"
                    :error-messages="[].concat(fieldErrors('form.endTime'))"
                    @blur="$v.form.endTime.$touch()"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <VueEditor
                  v-model="form.content"
                  label="Content"
                  :error-messages="[].concat(fieldErrors('form.content'))"
                  @blur="$v.form.content.$touch()"
                  :editor-toolbar="customToolbar"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState, mapGetters } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import DatePicker from "src/components/DatePicker.vue";
import TimePicker from "components/TimePicker.vue";
import { VueEditor } from "vue2-editor";

const defaultForm = {
  id: "",
  content: "",
  startDate: new Date(),
  startTime: new Date(),
  endDate: new Date(),
  endTime: new Date(),
};

export default {
  components: {
    AlertMessage,
    DatePicker,
    TimePicker,
    VueEditor,
  },
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      content: {
        required,
      },
      startDate: {},
      startTime: {},
      endDate: {},
      endTime: {},
    },
  },
  validationMessages: {
    form: {
      content: {
        required: "Content required",
      },
      startDate: {
        required: "Name required",
      },
      startTime: {},
      endDate: {
        required: "Type required",
      },
      endTime: {
        required: "Price required",
      },
    },
  },

  data() {
    return {
      showDialog: this.show,
      typeItems: ["Labor", "Parts"],
      form: {
        id: "",
        content: "",
        startDate: this.momentLocal().format("YYYY-MM-DD"),
        startTime: this.momentLocal().format("YYYY-MM-DD"),
        endDate: "23:59",
        endTime: "00:01",
      },

      dialog: false,
      valid: false,
      loading: false,
      customToolbar: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],

        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],

        ["clean"],
      ],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n) {
      if (!n) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
    formTitle() {
      return this.isEdit ? "Edit Announcement" : "Add Announcement";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
  },

  created() {},

  methods: {
    ...mapActions("announcement", ["create", "update"]),
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },
    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });

      if (this.isEdit) {
        this.form = {
          ...this.item,
          startDate: this.momentLocal(this.item.startDate).format("YYYY-MM-DD"),
          startTime: this.momentLocal(this.item.startDate).format("HH:mm"),
          endDate: this.momentLocal(this.item.endDate).format("YYYY-MM-DD"),
          endTime: this.momentLocal(this.item.endDate).format("HH:mm"),
        };
      } else {
        this.form = {
          ...defaultForm,
          startDate: this.momentLocal(new Date()).format("YYYY-MM-DD"),
          startTime: this.momentLocal(new Date()).format("HH:mm"),
          endDate: this.momentLocal(new Date()).format("YYYY-MM-DD"),
          endTime: this.momentLocal(new Date()).format("HH:mm"),
        };
      }
    },
    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultForm,
      };
    },

    completed() {
      this.$emit("onSucceded");
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form,
        startDate: this.localToUtc(
          this.form.startDate + " " + this.form.startTime
        ),
        endDate: this.localToUtc(this.form.endDate + " " + this.form.endTime),
      };

      if (this.isEdit) {
        await this.update(payload);
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.account.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>